import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiDialogsSpinnerComponent } from './spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FiSpinnerService } from '@fi-shared/fi-spinner/fi-spinner.service';

@NgModule({
    imports: [CommonModule, MatProgressSpinnerModule],
    declarations: [FiDialogsSpinnerComponent],
    providers: [FiSpinnerService],
})
export class FiSpinnerModule {}
